import { render, staticRenderFns } from "./ControlButton.vue?vue&type=template&id=fe9606e6&scoped=true&"
import script from "./ControlButton.vue?vue&type=script&lang=js&"
export * from "./ControlButton.vue?vue&type=script&lang=js&"
import style0 from "./ControlButton.vue?vue&type=style&index=0&id=fe9606e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9606e6",
  null
  
)

export default component.exports